export default __webpack_public_path__ + "static/media/gauge_90.52bedb5d.svg";